import { portalAPI } from './portalAPI';

import type { ListKey, ListView, ListViewCreate, ListViewDefault, ListViews, ListViewUpdate } from 'types/listViews';

/** Saved list views, one cache entry per list, tagged by its key. */
export const APIListViewsSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['ListViews'] }).injectEndpoints({
    endpoints: (builder) => ({
        getListViews: builder.query<ListViews, ListKey>({
            query: (listKey) => `/v1/list-views?listKey=${listKey}`,
            providesTags: (_result, _error, listKey) => [{ type: 'ListViews', id: listKey }],
        }),
        createListView: builder.mutation<ListView, ListViewCreate>({
            query: (body) => ({ url: '/v1/list-views', method: 'POST', body }),
            invalidatesTags: (_result, _error, { listKey }) => [{ type: 'ListViews', id: listKey }],
        }),
        updateListView: builder.mutation<ListView, { id: number; listKey: ListKey; body: ListViewUpdate }>({
            query: ({ id, body }) => ({ url: `/v1/list-views/${id}`, method: 'PUT', body }),
            invalidatesTags: (_result, _error, { listKey }) => [{ type: 'ListViews', id: listKey }],
        }),
        deleteListView: builder.mutation<void, { id: number; listKey: ListKey }>({
            query: ({ id }) => ({ url: `/v1/list-views/${id}`, method: 'DELETE' }),
            invalidatesTags: (_result, _error, { listKey }) => [{ type: 'ListViews', id: listKey }],
        }),
        setDefaultListView: builder.mutation<void, { listKey: ListKey; body: ListViewDefault }>({
            query: ({ listKey, body }) => ({ url: `/v1/list-views/default/${listKey}`, method: 'PUT', body }),
            invalidatesTags: (_result, _error, { listKey }) => [{ type: 'ListViews', id: listKey }],
        }),
    }),
});

export const {
    useGetListViewsQuery,
    useCreateListViewMutation,
    useUpdateListViewMutation,
    useDeleteListViewMutation,
    useSetDefaultListViewMutation,
} = APIListViewsSlice;
